import { Component, Input, OnInit } from "@angular/core";
import { EdtellProfileHeaderConfig } from "../../interface/edtell-profile-header-config.interface";

@Component({
  selector: "app-edtell-profile-header",
  templateUrl: "./edtell-profile-header.component.html",
  styleUrls: ["./edtell-profile-header.component.scss"],
})
export class EdtellProfileHeaderComponent implements OnInit {
  @Input()
  config: EdtellProfileHeaderConfig;

  constructor() {}

  ngOnInit() {}

  get isPinned(): boolean {
    let pinned = false;
    if (typeof this.config.isPinned == "function") {
      pinned = this.config.isPinned();
    } else {
      pinned = this.config.isPinned;
    }
    return pinned;
  }
}
